
import { Component, Watch } from 'vue-property-decorator'
import { Mixins } from 'vue-mixin-decorator'
import MixinInterface from '@/_mixins/index'
import ProjectMixin from '@/_mixins/project'

import AppToolbar from '@/_components/bar/appToolbar/appToolbar.vue'
import ForbiddenView from '@/views/App/views/ForbiddenView/ForbiddenView.vue'

@Component({
    components: { AppToolbar, ForbiddenView },
    mixins: [ProjectMixin],
})
export default class HSESettings extends Mixins<MixinInterface>(ProjectMixin) {
    get allowedAccess() {
        return this.hasPermission(this.currentProjectPermissions, this.requiredPermissions)
    }
}
